import { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler, useFieldArray } from "react-hook-form";
import { CenterBox, OnsiteProgress } from "../../customelements/CustomInput";
import { HttpPostData, JumpPage } from "../../common/Util";
import { LoginStateConext } from "../../context/AuthContext";
import { NewProductParam, LicenseDatas, ToPaymentConfirm, ContinueLicenses, PaymentPageType, ResponseParamBase } from "../../common/Types";
import market from "../../css/market.module.scss";
import base from "../../css/base.module.css";

export interface IFormInputs {
    userLicenseList: ContinueLicenses[]
}

type ProductData = {
    nonTaxPrice: number,
    taxPrice: number,
    includeTaxPrice: number,
}

export type ResponseParam = ResponseParamBase & {
    list: ContinueLicenses[],
    productParam: ProductData,
}

export type ResponseParam2 = ResponseParamBase & {
    data: LicenseDatas
}

export const ContinueLicense = () => {

    const navigate = useNavigate();
    const [dataList, setDataList] = useState<IFormInputs>({ userLicenseList: [] });
    const [productData, setProductData] = useState<ProductData>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isListCheck, setIsListCheck] = useState<boolean>(false);
    const loginState = useContext(LoginStateConext);
    const location = useLocation();
    const beforePageParam: NewProductParam = location.state as NewProductParam;

    const { register, handleSubmit, trigger, control, getValues, watch, formState: { errors, isValid }, reset } = useForm<IFormInputs>({
        defaultValues: {
            userLicenseList: dataList.userLicenseList
        },
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const { fields } = useFieldArray({
        name: "userLicenseList",
        control: control,
    });

    const watchFieldArray = watch("userLicenseList");
    const controlledFields = fields.map((field, index) => {
        return {
            ...field,
            ...watchFieldArray[index]
        };
    });

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {

        await HttpPostData<ResponseParam2>("/License/GetBuyContinueLicense",
            data.userLicenseList.filter((value, index, array) => { return (value.isChecked.length > 0) })
                .map((value, index, array) => { return { UserLicenseId: value.userLicenseId } })
            , setIsLoading)
            .then((response) => {
                return response.data.data;
            })
            .then((result) => {
                JumpPage<ToPaymentConfirm>("PaymentConfirm",
                    {
                        productParam: { quantity: 1, categoryCode: beforePageParam.categoryCode, productCode: beforePageParam.productCode, nonTaxPrice: productData?.nonTaxPrice ?? 0, taxPrice: productData?.taxPrice ?? 0, includeTaxPrice: productData?.includeTaxPrice ?? 0, postCode: "", address: "", customerName: "", phoneNumber: "", biko: "", isDelivery: false, paymentPageType: PaymentPageType.Continue, productName: "ClickerAce継続ライセンス" },
                        purchaseParam: result,
                        deliverySpan: 0,
                        test: "",
                    }
                    , "購入確認", navigate);
            })
            .catch(e => {
                //return { userLicenses: [], totalIncludeTaxPrice: 0, totalNonTaxPrice: 0, totalTaxPrice: 0 }
            });
    }

    useEffect(() => {
        (async () => {
            await HttpPostData<ResponseParam>("/License/GetUserPurchaseLicense", { Email: loginState.loginInfo.email }, setIsLoading
            ).then((response) => {
                setProductData(response.data.productParam);
                reset({ userLicenseList: response.data.list });
                setIsListCheck(controlledFields.some((value, index, array) => { return value.isChecked }));
            }).catch(e => {
                
            });
        })()
    }, []);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                {isLoading ?
                    <CenterBox>
                        <OnsiteProgress></OnsiteProgress>
                    </CenterBox>
                    :
                    <>
                        <section className={market.marketArea}>
                            <div className={market.marketAreaInner}>
                                <div className={base.centerContents} style={{ marginBottom: "50px" }}>
                                    <div className={base.messageFont}>継続利用するライセンスを選択してください。</div>
                                </div>

                                <table className={base.pcTable} width="100%">
                                    <thead>
                                        <tr>
                                            <th>延長</th>
                                            <th>ライセンスコード</th>
                                            <th>有効期限</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fields.map((field, index) => {
                                            return (
                                                <tr key={index} className={field.isLValidLimit ? base.pcTable : base.pcTableDisable}>
                                                    <td>
                                                        <input type="checkbox"
                                                            {...register(`userLicenseList.${index}.isChecked` as const)}
                                                            onChange={(event) => {
                                                                let pElem = event.target.parentElement;
                                                                while (pElem != null && pElem.tagName != "TR") {
                                                                    pElem = pElem?.parentElement;
                                                                }
                                                                if (pElem != null) {
                                                                    pElem.className = event.target.checked ? base.pcTableSelected : field.isLValidLimit ? base.pcTable : base.pcTableDisable;
                                                                }
                                                                setIsListCheck(getValues("userLicenseList").some((value, index, array) => { return value.isChecked.length > 0 }) || event.target.checked);
                                                            }}
                                                            ></input>
                                                    </td>
                                                    <td>
                                                        {field.licenseKey}
                                                    </td>
                                                    <td>
                                                        <section className={base.forPc}>
                                                            {field.limitSpanStr}
                                                        </section>
                                                        <section className={base.forSp}>
                                                            {field.limitSpanStartStr}<br />～<br />{field.limitSpanEndStr}
                                                        </section>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                        }
                                    </tbody>
                                </table>
                                <div className={market.marketFooterArea}>
                                    <button className={market.marketBackButton} type="button" onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>戻る</button>
                                    <button className={market.marketButton} disabled={!isListCheck || isLoading} type="submit">購入確認</button>
                                    <button style={{ visibility: "hidden" }} className={market.marketBackButton}>＜　進む</button>
                                </div>
                            </div>
                        </section>
                    </>
                }
            </form>
        </>
    );
}